import { useEffect, useRef, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "./components/Navbar";

import Home from "./pages/Home";
import Products from "./pages/Products";
import ProductDetails from "./pages/ProductDetails";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Admin from "./pages/Admin";
import ErrorBoundary from "./components/ErrorBoundary";

function AnimatedRoutes() {
  const location = useLocation();
  const [routeLoading, setRouteLoading] = useState(false);
  const firstRenderRef = useRef(true);

  useEffect(() => {
    if (firstRenderRef.current) {
      firstRenderRef.current = false;
      return undefined;
    }

    setRouteLoading(true);
    const timer = setTimeout(() => {
      setRouteLoading(false);
    }, 420);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return (
    <>
      {routeLoading && (
        <div className="route-transition-loader" role="status" aria-live="polite">
          <div className="route-transition-spinner"></div>
          <p>Loading page...</p>
        </div>
      )}

      <div className="page-transition-wrap" key={location.pathname}>
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetails />} />
          <Route path="/services" element={<Services />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* keep admin last */}
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </div>
    </>
  );
}

function App() {
  return (
    <>
      <ErrorBoundary>
        <BrowserRouter>
          <Navbar />
          <AnimatedRoutes />
        </BrowserRouter>
      </ErrorBoundary>
    </>
  );
}

export default App;
